module.exports = __webpack_public_path__ + "img/nissan.6650e78f.png";